export default __webpack_public_path__ + "assets/images/7f55869fa9443c149bfb3d3aca4ed1ab.png";